import React, { useState } from "react";
import maskBG from "assets/images/others/minor-side-images/maskBg.png";
import badgesBg from "../../../assets/images/others/host-side-images/badgesBg.png";
import profilePic from "../../../assets/images/others/host-side-images/attende1.png";
import representatives1 from "../../../assets/images/others/host-side-images/representatives1.png";
import representatives2 from "../../../assets/images/others/host-side-images/representatives2.png";
import { ReactComponent as ReviewStarSvg } from "../../../assets/images/svgs/reviewStarSvg.svg";
import { ReactComponent as Star } from "../../../assets/images/svgs/attendee/attende-star.svg";
import { ReactComponent as FavouriteChart } from "../../../assets/images/svgs/attendee/attende-favorite-chart.svg";
import { ReactComponent as User } from "../../../assets/images/svgs/attendee/attende-profile-2user.svg";
import BadgeImg from "../../../assets/images/others/attendee-side-images/badge-1.png";
import { siteRoutes } from "../../../utils/helpers/enums/routes";
import MinorBreadcrumb, {
  MinorBreadcrumbLink,
} from "../../../components/breadcrumbs/MinorBreadcrumb";
import useStore from "../../../hooks/useStore";
import { GENDERS } from "../../../utils/helpers/enums/shared.enum";

interface Representative {
  id: number;
  profileImage: string;
  title: string;
  reviews: string;
}
const FavoriteHost = () => {
  const { getUser } = useStore();
  const { user = null } = getUser();
  const data: Representative[] = [
    {
      id: 1,
      profileImage: representatives1,
      title: "Bertha Valdez",
      reviews: "5.0",
    },
    {
      id: 2,
      profileImage: representatives2,
      title: "Earl Bowman",
      reviews: "5.0",
    },
    {
      id: 3,
      profileImage: representatives1,
      title: "Bertha Valdez",
      reviews: "5.0",
    },
    {
      id: 4,
      profileImage: representatives2,
      title: "Earl Bowman",
      reviews: "5.0",
    },
    {
      id: 5,
      profileImage: representatives1,
      title: "Bertha Valdez",
      reviews: "5.0",
    },
    {
      id: 6,
      profileImage: representatives2,
      title: "Earl Bowman",
      reviews: "5.0",
    },
    {
      id: 7,
      profileImage: representatives1,
      title: "Bertha Valdez",
      reviews: "5.0",
    },
    {
      id: 8,
      profileImage: representatives2,
      title: "Earl Bowman",
      reviews: "5.0",
    },
  ];

  const breadcrumbLinks: MinorBreadcrumbLink[] = [
    { title: "Home", path: siteRoutes.minorHome },
    {
      title: "Favorite Host",
      path: siteRoutes.minorFavoriteHost,
    },
  ];
  return (
    <div>
      <div
        style={{
          backgroundImage: `url(${maskBG}) `,
        }}
        className="bg-cover bg-center bg-no-repeat h-full md:h-[300px] w-full"
      >
        <div className=" h-full ">
          <div className="container">
            <MinorBreadcrumb links={breadcrumbLinks} />
            <div className="flex  flex-col gap-2">
              <h2 className="text-4xl text-primaryBlueText">
                Hello Lauren Rhodes!
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container md:mt-[-145px]">
        <div className="flex justify-between flex-wrap  items-center">
          <div className="flex items-end gap-4">
            <img
              className="w-36 h-36 object-cover border-4 border-white rounded-full"
              src={profilePic}
              alt="profilePic"
            />
            <span className="text-3xl text-blackie font-semibold mb-4">
              Rhodes Family
            </span>
          </div>
          <div className="flex flex-wrap items-center gap-4">
            <div className="flex items-center gap-4 sm:gap-2  flex-wrap bg-attendeBlueBg rounded-lg lg:rounded-full px-3 py-3 mt-6">
              <span className="flex items-center text-base whitespace-nowrap text-primaryBlueText">
                <Star className="mr-1 " /> 1 Year Member
              </span>
              <span className="flex items-center text-base whitespace-nowrap text-primaryBlueText">
                <User className="mr-1" /> 12 Members
              </span>
              <span className="flex items-center whitespace-nowrap text-base text-primaryBlueText">
                <FavouriteChart
                  className="mr-1"
                  style={{ stroke: "minor-girl-color" }}
                />
                24 Exp.
              </span>
            </div>
            <div className="w-[210px] h-[230px] rounded-xl bg-white flex flex-col items-center justify-center gap-2 p-4">
              <img src={BadgeImg} alt="BadgeImg" />
              <span className="text-base text-blackie font-medium">
                Member for 1 year
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="container min-h-screen">
        <div className="flex flex-wrap items-center gap-4 py-5">
          {data.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center justify-center p-4 rounded-lg w-[235px] h-[260px] cursor-pointer"
              style={{
                backgroundImage: `url(${badgesBg})`,
                backgroundSize: "cover",
              }}
            >
              <div className="hover:scale-110 transition-transform duration-300">
                <img
                  className="w-[98px] h-[98px] rounded-full"
                  src={item.profileImage}
                  alt={item.title}
                />
              </div>
              <span className="text-base font-semibold mt-2 text-blackie">
                {item.title}
              </span>
              <span className="text-sm mt-1 text-labelTextColor flex items-center">
                <ReviewStarSvg className="w-4 h-4 mr-1" /> {item.reviews}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FavoriteHost;
